"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _TermsAndConditions = require("./components/TermsAndConditions");
Object.keys(_TermsAndConditions).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TermsAndConditions[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _TermsAndConditions[key];
    }
  });
});
